export interface SavedAttributes {
  attrs: { [key: string]: string }; //this is a dictionary in csharp
}
export enum SavedAttributeName {
  OrderGroup = "orderGroup",
  FilterDays = "filterDays",
  FilterResultLimit = "filterResultLimit",
  //From/To locations used on the last New Stock Request
  StockRequestFrom = "stockRequestFrom",
  StockRequestTo = "stockRequestTo",
  //From/To location filters on the Stock Requests list
  StockRequestFilterFrom = "stockRequestFilterFrom",
  StockRequestFilterTo = "stockRequestFilterTo",
}
